import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { requestOTP, ValidateOTP, GetPriceRule, RegisterMarriage, RegisterPayment, ValidateEmail } from './module';

const initialState = {
    mySession: null,
    OTPKey: null,
    countdownNo: 60,
    marriageFormData: JSON.parse(sessionStorage.getItem('mfs')),
    isRequestedOtp: false,
    priceRules: null,
    disableBtn: false,
    status: "idle",
    ActionStatus: "",
    errorMessage: "",
    paymentloading: false
};

export const ValidateEmailAsync = createAsyncThunk(
    'marriageSummary/requestOTP',
    async (data, ThunkAPI) => {
        const response = await ValidateEmail(data);
        return response;
    }
);

export const GetPriceRuleAsync = createAsyncThunk(
    'marriageSummary/GetPriceRule',
    async (data, ThunkAPI) => {
        const response = await GetPriceRule();
        return response;
    }
);

export const resendOTPAsync = createAsyncThunk(
    'marriageSummary/resendOTP',
    async (data, ThunkAPI) => {
        const response = await requestOTP(data);
        return response;
    }
);

export const RegisterMarriageAsync = createAsyncThunk(
    'marriageSummary/RegisterMarriage',
    async (json, ThunkAPI) => {
        const response = await RegisterMarriage(json);
        const resultPromise = Promise.resolve(response);
        resultPromise.then((r, index) => {
            var data = r;
            if (data && data.Status === 'OK') {
                sessionStorage.removeItem('mfs');
                window.wogaaCustom.completeTransactionalService('ArchivesOnline-2858'); 
                var payment_data = {
                    OrderCode: data.Orders[0].OrderCode,
                    InvoiceIds: [data.Orders[0].Invoices[0].InvoiceId]
                }
               ThunkAPI.dispatch(RegisterPaymentAsync(payment_data));
            } else {
                alert('Failed to get payment data!');
            }

        })
        return response;
    }
);

export const RegisterPaymentAsync = createAsyncThunk(
    'marriageSummary/RegisterPayment',
    async (data, ThunkAPI) => {
        const response = await RegisterPayment(data);
        return response;
    }
);

export const ValidateOTPAsync = createAsyncThunk(
    'marriageSummary/validateOTP',
    async (data, ThunkAPI) => {
        const response = await ValidateOTP(data);
        const resultPromise = Promise.resolve(response);
        resultPromise.then((r, index) => {
            if (r && r.Status === 'OK') {
               ThunkAPI.dispatch(RegisterMarriageAsync(JSON.parse(sessionStorage.getItem('mfs'))));
            } else {
                alert('Failed to validate OTP');
            }

        })
        return response;
    }
);

export const marriageSummarySlice = createSlice({
    name: 'marriageSummary',
    initialState,
    reducers: {
        clearAction: (state, action) => {
            //state.isRequestedOtp = null;
            state.paymentloading = false;
        },
        ChangeCountdownNumber: (state, action) => {
            state.countdownNo = action.payload;
        },
        triggerDisableBtn: (state, action) => {
            state.disableBtn = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(ValidateEmailAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(ValidateEmailAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(ValidateEmailAsync.fulfilled, (state, action) => {
            state.status = 'idle';
            if (action.payload && action.payload.Status !== 'OK') {
                alert(action.payload.ErrorMessage);
            } else {
                state.isRequestedOtp = true;
                state.OTPKey = action.payload.OTPKey
            }
        });
        builder.addCase(resendOTPAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(resendOTPAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(resendOTPAsync.fulfilled, (state, action) => {
            state.status = 'idle';
            if (action.payload && action.payload.Status !== 'OK') {
                alert(action.payload.ErrorMessage);
            } else {
                state.OTPKey = action.payload.OTPKey
            }
        });
        builder.addCase(ValidateOTPAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(ValidateOTPAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(ValidateOTPAsync.fulfilled, (state, action) => {
            state.status = 'idle';
        });
        builder.addCase(GetPriceRuleAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(GetPriceRuleAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(GetPriceRuleAsync.fulfilled, (state, action) => {
            state.status = 'idle';
            if (action.payload && action.payload.Status !== 'OK') {
                alert(action.payload.ErrorMessage);
            } else {
                state.priceRules = action.payload.PriceRules
            }
        });
        builder.addCase(RegisterMarriageAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(RegisterMarriageAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(RegisterMarriageAsync.fulfilled, (state, action) => {
            state.status = 'idle';
            if (action.payload && action.payload.Status !== 'OK') {
                alert(action.payload.ErrorMessage);
            }
        });
        builder.addCase(RegisterPaymentAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(RegisterPaymentAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(RegisterPaymentAsync.fulfilled, (state, action) => {
            state.status = 'idle';
            if (action.payload && action.payload.Status !== 'OK') {
                alert(action.payload.ErrorMessage)
            }else{
                state.paymentloading = true;
                var payment = action.payload;
                var form = document.createElement("form");
                var paymentElement = document.createElement("input");
    
                form.method = "POST";
                form.action = payment.Url;
    
                paymentElement.value = payment.PaymentXml;
                paymentElement.type = "hidden";
                paymentElement.name = "PAYMENT";
    
                form.appendChild(paymentElement);
    
                document.body.appendChild(form);
    
                form.submit();
            }

        });
        
    }
});

export const { clearAction, triggerDisableBtn, ChangeCountdownNumber } = marriageSummarySlice.actions;
export const pagesState = (state) => state.marriageSummary;
export const formData = (state) => state.marriageSummary.marriageFormData;
export const mySession = (state) => state.Session.mySession;
export const myLibs = (state) => state.Session.myLibs;
export const paymentloading = (state) => state.marriageSummary.paymentloading;

export const checkOutCurCart = (data) => (dispatch, getState) => {
    dispatch(RegisterMarriageAsync(JSON.parse(sessionStorage.getItem('mfs'))));
};

export default marriageSummarySlice.reducer;
